import type { ScenarioId } from '../shared/contract';

export interface RoleLabels {
  /** Label for the human speaker. */
  user: string;
  /** Label for the AI speaker. */
  ai: string;
  /** Short name of the AI character shown in the room. */
  aiName: string;
  aiBlurb: string;
}

export const ROLE_LABELS: Record<ScenarioId, RoleLabels> = {
  roleplay_screening: {
    user: 'You (recruiter)',
    ai: 'Candidate',
    aiName: 'Candidate',
    aiBlurb: 'Business Development Associate applicant',
  },
  tania_followup: { user: 'You', ai: 'Tania', aiName: 'Tania', aiBlurb: 'Talent Acquisition Manager' },
  ta_competency: { user: 'You (candidate)', ai: 'Tania', aiName: 'Tania', aiBlurb: 'Senior TA competency interview' },
  hiring_manager_intake: { user: 'You (recruiter)', ai: 'Hiring manager', aiName: 'Hiring manager', aiBlurb: 'Sales leader opening a role' },
  custom: { user: 'You', ai: 'Interviewer', aiName: 'Interviewer', aiBlurb: 'Custom interview' },
};

export const NEARLY_UP_MESSAGE: Record<ScenarioId, string> = {
  roleplay_screening: '[SYSTEM] Time is nearly up. Close the Q&A as Tania with one brief, warm sentence.',
  tania_followup: '[SYSTEM] Time is nearly up. Finish your current question and close the conversation briefly.',
  ta_competency: '[SYSTEM] Time is nearly up. Finish the current question and close the interview politely.',
  hiring_manager_intake: '[SYSTEM] Time is nearly up; the recruiter will close the call. Stay in character.',
  custom: '[SYSTEM] Time is nearly up. Wrap up with a short closing; do not give a full debrief.',
};

export const TIME_UP_MESSAGE =
  '[SYSTEM] Time is up. Close the conversation in one short sentence, staying in character.';

/** Screening checklist for the recruiter, from the Ideals role-play booklet. */
export const SCREENING_CHECKLIST: ReadonlyArray<{ id: string; label: string }> = [
  { id: 'overview', label: 'Short overview of Ideals and the BDA role' },
  { id: 'motivation', label: 'What drives the candidate; does it fit the role?' },
  { id: 'background', label: 'Walk through relevant experience and current situation' },
  { id: 'metrics', label: 'Sales metrics: target clients, deal size, cycle length, quota attainment, sales motion' },
  { id: 'surface', label: 'Probe surface-level answers (depth of questioning)' },
  { id: 'cbi', label: 'CBI question for Planning & Organization (CARE: Context, Action, Role, Effect)' },
  { id: 'present', label: 'Present the role; check expectations, comp and timing' },
  { id: 'rapport', label: 'Build rapport; leave room for candidate questions' },
  { id: 'next', label: 'Close with clear next steps' },
];
